import AuthResource from "./ApiResources/AuthResource";
import Palettes     from "../Palette/Store/Palettes";

export default class Registration {
    name;
    email;
    password;
    palettes = [];

    constructor(name, email, password) {
        this.name = name;
        this.email = email;
        this.password = password;
    }

    addPalettes() {
        let palettesStore = new Palettes();
        this.palettes = palettesStore.getPalettes();
    }

    send() {
        this.addPalettes();

        return new AuthResource().register(this)
    }

}
